import {
  View,
  Text,
  Image,
  TouchableOpacity,
  ActivityIndicator,
  ScrollView,
  Platform,
} from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { useState, useEffect } from "react";
import { router, useLocalSearchParams } from "expo-router";
import Animated, { FadeInDown, ZoomIn } from "react-native-reanimated";
import { Toast } from "react-native-toast-notifications";
import customAxios from "../../../../utils/customAxios";
import i18n from "../../../../locales/i18n";
import FloatingLabelInput from "../../../../components/FloatingLabelInput";
import StandardNavigation from "../../../../components/navigation/StandardNavigation";
import DeptHeaderIcon from "../../../../assets/dept/dept.svg";
import WebAddDetteScreen from "../../../../components/web/WebAddDetteScreen";

const index = () => {
  // Return web version for web platform
  if (Platform.OS === "web") {
    return <WebAddDetteScreen />;
  }
  const [name, setName] = useState("");
  const [amount, setAmount] = useState("");
  const [phone, setPhone] = useState("");
  const locale = i18n.locale;
  const [buttonSpinner, setButtonSpinner] = useState(false);
  const { total, factureId } = useLocalSearchParams();

  // Convert params to strings for proper handling
  const totalString = Array.isArray(total) ? total[0] : total;
  const factureIdString = Array.isArray(factureId) ? factureId[0] : factureId;

  const shouldShowTotal = totalString && parseFloat(totalString) > 0;
  const date = new Date().toISOString().slice(0, 10).replace(/-/g, "/");

  useEffect(() => {
    if (totalString && parseFloat(totalString) > 0) {
      setAmount(totalString);
    }
  }, [totalString]);

  // Function to check if user exists and get their debt info
  const checkExistingUser = async (phone: string) => {
    try {
      const response = await customAxios.get(
        `/debt/search/byinfo?info=${phone}`,
        {
          withCredentials: true,
        }
      );

      if (response.data && response.data.length > 0) {
        // User exists, return their debt info
        return response.data[0];
      }
      return null;
    } catch (error) {
      return null;
    }
  };

  const handelAdd = async () => {
    if (!name || !amount || !phone) {
      Toast.show(i18n.t("fillall"), {
        type: "danger",
      });
      return null;
    }

    // Phone validation for Algerian numbers (10 digits exactly)
    if (!/^\d{10}$/.test(phone.replace(/[\s-]/g, ""))) {
      Toast.show(i18n.t("invalidPhoneNumber"), {
        type: "danger",
      });
      return null;
    }

    setButtonSpinner(true);

    // Check if user already exists
    const existingUser = await checkExistingUser(phone);

    if (totalString) {
      await customAxios
        .post(
          `/debt/facture`,
          {
            fullname: name,
            phone: phone,
            amount: amount,
            factureid: factureIdString,
          },
          { withCredentials: true }
        )
        .then(async (res) => {
          Toast.show(i18n.t("addsuccess"), {
            type: "success",
          });

          router.push("/(drawer)/scanner");
        })
        .catch((error) => {
          // Check if this is a free tier limit exceeded error (403)
          if (error?.response?.status === 403) {
            const errorMessage = error?.response?.data?.error || "";
            if (
              typeof errorMessage === "string" &&
              errorMessage.toLowerCase().includes("free tier")
            ) {
              // Show upgrade message and navigate to limits page
              Toast.show(
                i18n.t("freeTierLimitExceeded") +
                  " " +
                  i18n.t("upgradeRequired"),
                {
                  type: "danger",
                  duration: 5000,
                }
              );

              // Navigate to limits page after a short delay
              setTimeout(() => {
                router.push("/(drawer)/params/limits");
              }, 2000);
              return;
            }
          }

          const errorMessage = error.response?.data?.message || error.message;

          if (errorMessage) {
            Toast.show(errorMessage, {
              type: "danger",
            });
          } else {
            Toast.show(i18n.t("addfaild"), {
              type: "danger",
            });
          }
        })
        .finally(() => {
          setButtonSpinner(false);
        });
    } else {
      await customAxios
        .post(
          `/debt`,
          {
            fullname: name,
            phone: phone,
            amount: amount,
          },
          { withCredentials: true }
        )
        .then(async (res) => {
          Toast.show(i18n.t("addsuccess"), {
            type: "success",
          });

          // Clear form fields
          setName("");
          setPhone("");
          setAmount("");

          // Navigate back to debts list
          router.back();
        })
        .catch((error) => {
          // Check if this is a free tier limit exceeded error (403)
          if (error?.response?.status === 403) {
            const errorMessage = error?.response?.data?.error || "";
            if (
              typeof errorMessage === "string" &&
              errorMessage.toLowerCase().includes("free tier")
            ) {
              // Show upgrade message and navigate to limits page
              Toast.show(
                i18n.t("freeTierLimitExceeded") +
                  " " +
                  i18n.t("upgradeRequired"),
                {
                  type: "danger",
                  duration: 5000,
                }
              );

              // Navigate to limits page after a short delay
              setTimeout(() => {
                router.push("/(drawer)/params/limits");
              }, 2000);
              return;
            }
          }

          const errorMessage = error.response?.data?.message || error.message;

          if (errorMessage) {
            Toast.show(errorMessage, {
              type: "danger",
            });
          } else {
            Toast.show(i18n.t("addfaild"), {
              type: "danger",
            });
          }
        })
        .finally(() => {
          setButtonSpinner(false);
        });
    }
  };

  return (
    <View style={{ flex: 1, backgroundColor: "#f5f5f5" }}>
      {/* Standard Navigation */}
      <StandardNavigation
        title={i18n.t("addnewdette")}
        showBackButton={true}
        showMenuButton={true}
        showLogo={true}
        icon={<DeptHeaderIcon width={30} height={30} />}
      />

      <ScrollView className="flex-1 " style={{ backgroundColor: "#f5f5f5" }}>
        <View className="flex-1   ">
          {/* total and date */}
          {shouldShowTotal && (
            <View className="gap-8 rounded-b-2xl flex px-8 py-4 bg-white ">
              <View
                className={`${
                  locale == "ar" ? "flex-row-reverse" : "flex-row"
                } justify-between items-center`}
              >
                <Text className={"text-xl font-semibold"}>
                  {" "}
                  {i18n.t("total")} :{" "}
                </Text>
                <Text className="text-xl font-semibold">
                  {totalString} {i18n.t("currency")}
                </Text>
              </View>
              <View
                className={`${
                  locale == "ar" ? "flex-row-reverse" : "flex-row"
                } justify-between items-center`}
              >
                <Text className={"text-xl font-semibold text-center"}>
                  {" "}
                  {i18n.t("calender")}{" "}
                </Text>
                <Text className="text-xl font-semibold text-center">
                  {date}
                </Text>
              </View>
            </View>
          )}

          <Animated.View
            entering={ZoomIn.delay(50).duration(500)}
            className={`justify-center flex-1 items-center gap-x-4 mt-4`}
          >
            <FloatingLabelInput
              label={i18n.t("nameofdain")}
              value={name}
              onChangeText={setName}
              locale={locale}
            />

            <FloatingLabelInput
              label={i18n.t("phonenumber")}
              value={phone}
              onChangeText={setPhone}
              locale={locale}
            />

            <View style={{ width: "85%" }}>
              <FloatingLabelInput
                label={`${i18n.t("quantityofdette")}${
                  shouldShowTotal ? " ★" : ""
                }`}
                value={amount}
                onChangeText={setAmount}
                locale={locale}
                editable={!shouldShowTotal}
                style={
                  shouldShowTotal
                    ? {
                        backgroundColor: "#e0f2fe",
                        borderColor: "#0ea5e9",
                        borderWidth: 2,
                        fontWeight: "bold",
                      }
                    : {}
                }
                keyboardType="numeric"
              />
              {shouldShowTotal && (
                <Text
                  style={{
                    fontSize: 12,
                    color: "#0ea5e9",
                    textAlign: locale === "ar" ? "right" : "left",
                    marginTop: 4,
                    fontWeight: "600",
                  }}
                >
                  ✓ {i18n.t("amountFilledFromSale")}
                </Text>
              )}
            </View>

            <Animated.View
              entering={FadeInDown.delay(50).duration(500)}
              className={`w-full flex mt-32 items-center justify-center`}
              style={{ width: "85%" }}
            >
              <TouchableOpacity
                style={{ width: "100%", borderRadius: 9999 }}
                onPress={handelAdd}
              >
                <LinearGradient
                  colors={["rgba(19, 121, 162, 1)", "rgba(5, 150, 208, 1)"]}
                  style={{
                    flexDirection: locale == "fr" ? "row" : "row-reverse",
                    borderRadius: 9999,
                    marginTop: 80,
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 16,
                    paddingHorizontal: 16,
                    paddingVertical: 8,
                  }}
                >
                  {buttonSpinner ? (
                    <ActivityIndicator size="small" color="white" />
                  ) : (
                    <Text className="text-white text-2xl py-2 font-bold">
                      {i18n.t("confirm")}
                    </Text>
                  )}
                </LinearGradient>
              </TouchableOpacity>
            </Animated.View>
          </Animated.View>
        </View>
      </ScrollView>
    </View>
  );
};

export default index;
